module.exports = __webpack_public_path__ + "img/carbon_warning-square.9ccb4d95.svg";